import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { buildEdgeAuthStartUrl } from '@cortex/core-types';
import { authApi } from '@/lib/api';
import { queryKeys } from '@/lib/query-keys';

/**
 * @graph-stack quality-atelier
 * @graph-domain Quality
 * @graph-business Google OAuth認証フック。ログイン/ログアウト・ユーザー情報取得を提供（Workspaceログインのみ・ロール別権限チェックなし）
 * @graph-connects authApi [calls] 認証APIクライアント呼び出し
 * @graph-connects queryKeys [calls] クエリキー生成
 */
export function useAuth() {
  const queryClient = useQueryClient();

  const { data, isLoading, error, refetch } = useQuery({
    queryKey: queryKeys.auth.user(),
    queryFn: authApi.getCurrentUser,
    staleTime: 5 * 60 * 1000,
    retry: false,
  });

  const user = data?.user ?? null;
  const expiresAt = data?.expiresAt ?? null;

  const loginMutation = useMutation({
    mutationFn: () => {
      window.location.href = buildEdgeAuthStartUrl(window.location.href);
      return Promise.resolve();
    },
  });

  const logoutMutation = useMutation({
    mutationFn: authApi.logout,
    onSuccess: () => {
      queryClient.setQueryData(queryKeys.auth.user(), null);
      window.location.href = '/login';
    },
  });

  return {
    user,
    expiresAt,
    isAuthenticated: !!user,
    isLoading,
    error,
    refetch,
    login: loginMutation.mutate,
    logout: logoutMutation.mutate,
    isLoggingIn: loginMutation.isPending,
    isLoggingOut: logoutMutation.isPending,
  };
}
